import React from "react"

const TestAdmin = () => {
  return <h1>Admin Only</h1>
}

export default TestAdmin
